import React, { useEffect, useState } from 'react';
import { Layout, Popconfirm, message, Button, Table, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useDispatch } from 'react-redux';
import { readEntities, deleteEntity } from '../actions/entity';
import { PageHeader } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';

function Entities() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { Content } = Layout;
    const [dataSource, setDataSource] = useState([]);

    const deleteEntityAction = (id) => {
        dispatch(deleteEntity(id)).then((response) => {
            message.success(t('entities.message.delete-success'));
            setDataSource(dataSource.filter(item => item.id !== id));
        }).catch(e => {
            console.log(e);
            message.error(t('entities.message.delete-failed'));
        });
    }

    const columns = [
        {
            title: t('entities.columns.name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('entities.columns.slug'),
            dataIndex: 'slug',
            key: 'slug',
        },
        {
            title: t('entities.columns.host'),
            dataIndex: 'host',
            key: 'host',
        },
        {
            title: t('entities.columns.path'),
            dataIndex: 'path',
            key: 'path',
        },
        {
            title: t('entities.columns.status'),
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (typeof record.status !== 'undefined' && record.status === true) {
                    return t('entities.columns.status.enabled');
                } else {
                    return t('entities.columns.status.disabled');
                }
            }
        },
        {
            title: t('entities.columns.created'),
            dataIndex: 'createdAt',
            key: 'createdAt'
        },
        {
            title: t('entities.columns.actions'),
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => <Space>
                <Button type="primary" href={`/settings/entity/${record.id}`}>{t('entities.actions.edit')}</Button>
                <Popconfirm
                    title={t('entities.message.delete-confirm')}
                    onConfirm={() => deleteEntityAction(record.id)}
                    okText={t('entities.actions.delete-ok')}
                    cancelText={t('entities.actions.delete-cancel')}
                >
                    <Button type="primary" danger>{t('entities.actions.delete')}</Button>
                </Popconfirm>
            </Space>

        }
    ];

    useEffect(() => {
        dispatch(readEntities()).then((response) => {
            if (typeof response.result !== 'undefined') {
                setDataSource(response.result);
            } else {
                setDataSource([]);
            }
        }).catch((error) => {
            try {
                setDataSource([]);
                let responseMessage = error.response.data.message;
                console.log(responseMessage);
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    }, [dispatch]);

    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <PageHeader
                        className="site-page-header"
                        onBack={() => navigate('/dashboard')}
                        title={t('entities.title')}
                        subTitle={t('entities.subtitle')}
                        extra={[
                            <Button key="create" type="primary" href={'/settings/entity'}>{t('entities.actions.new')}</Button>
                        ]}
                    />
                    <Table
                        rowKey={record => record.id}
                        dataSource={dataSource}
                        columns={columns} />
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default Entities;